<template>
  <div>
    <SelectorPanel
      type="collaboration"
      text="Content"
      :disabled="disabled"
      :force-close="forceClose"
      @open="handlePanelOpen"
    >
      <v-container
        v-if="isOpen"
        class="pa-0 hyp-collab-container"
        :class="{
          'hyp-collab-container-with': hasFolders,
          'hyp-collab-container-without': !hasFolders,
        }"
      >
        <v-row dense row>
          <v-col
            class="px-0"
            :class="{
              'col-3': hasFolders,
              'col-12': !hasFolders,
            }"
          >
            <SelectorPanelHeader
              type="collaboration"
              title="Content"
              @click-close="handleClickClose"
            ></SelectorPanelHeader>
            <v-row dense row>
              <v-col class="hyp-collab-tree-container col-12">
                <CollaborationTree
                  :initialize="refresh"
                  @has-folders="handleHasFolders"
                  @click-select="handleClickSelect"
                  @click-edit-save="handleClickEditSave"
                  @click-add="handleCickAddFolder"
                ></CollaborationTree>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            v-if="hasFolders"
            class="pl-4 pr-3 hyp-collab-details-container col-9"
          >
            <CollaborationContent
              v-if="currentFolder"
              :folder="currentFolder"
              :refresh="refresh"
              @click-folder-delete="handleClickFolderDelete"
              @click-folder-link="handleClickFolderLink"
            ></CollaborationContent>
          </v-col>
        </v-row>
      </v-container>
    </SelectorPanel>
  </div>
</template>

<script>
export default {
  name: "CollaborationSelector",
  components: {
    SelectorPanel: () => import("@/components/common/SelectorPanel"),
    SelectorPanelHeader: () =>
      import("@/components/common/SelectorPanelHeader"),
    CollaborationTree: () =>
      import("@/components/collaboration/CollaborationTree"),
    CollaborationContent: () =>
      import("@/components/collaboration/CollaborationContent"),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    hasFolders: false,
    currentFolder: null,
    refresh: new Date().toISOString(),
    forceClose: null,
    isOpen: false,
  }),
  methods: {
    handleClickClose() {
      this.forceClose = new Date().toISOString();
    },
    handlePanelOpen(open) {
      this.isOpen = open;
      if (open) {
        this.refresh = new Date().toISOString();
      }
    },
    handleHasFolders(hasFolders) {
      this.hasFolders = hasFolders;
    },
    handleClickSelect(item) {
      if (item) {
        this.currentFolder = item;
      }
    },
    handleClickEditSave(item) {
      if (item) {
        this.currentFolder = item;
      }
    },
    handleCickAddFolder(folderId) {
      if (folderId) {
        this.currentFolder = { id: folderId };
      }
      this.refresh = new Date().toISOString();
    },
    handleClickFolderDelete() {
      this.refresh = new Date().toISOString();
    },
    handleClickFolderLink() {
      this.refresh = new Date().toISOString();
    },
  },
};
</script>

<style scoped>
.hyp-collab-container {
  height: 99vh !important;
  padding: 0 !important;
}
.hyp-collab-container {
  width: 1200px;
}
.hyp-collab-container-without {
  width: 300px;
}
.hyp-collab-tree-container {
  overflow-y: auto;
  height: 90vh !important;
}
.hyp-collab-details-container {
  overflow-y: auto;
  height: 98vh !important;
  border-left: 1px solid #e4e4e4;
}
.hyp-form-tree-container {
  max-height: 300px;
  width: 320px;
  overflow-y: scroll;
  border-bottom: 1px solid #b5b5b5;
}
</style>
